<template>
    <div class="node">
        <div class="placeholder"></div>
        <div class="node-bg"></div>
        <div class="node-swipe">
            <Swipe class="swipe" :autoplay="3000" indicator-color="white">
                <SwipeItem>
                    <div class="swipe-item">
                        <img src="../../assets/img/node/swipe1.png" alt="" />
                    </div>
                </SwipeItem>
            </Swipe>
        </div>
        <div class="tags">
            <div :class="{ active: tabActive == 1 }" @click="tabActive = 1">{{ $t('node.ecology') }}</div>
            <div :class="{ active: tabActive == 2 }" @click="tabActive = 2">{{ $t('node.meNode') }}</div>
        </div>
        <div v-if="tabActive === 1">
            <div class="card" v-for="(item,i) in listnode" :key="i">
                <div>
                    <div class="card-l">
                        <!-- <div class="tag">
                            <img src="../../assets/img/node/icon1.png" alt="">
                        </div> -->
                        <img :src="getImg(i)" alt="" />
                    </div>
                    <div class="card-r">
                        <div class="card-r-l">
                            <div>{{ getNodeName(i) }}</div>
                            <div>$ {{item.price}}</div>
                            <div class="card-r-l-b">
                                 <span>{{ $t('home.limited') }} {{item.count-item.usecount}} {{ $t('home.mat') }}</span>
                            </div>
                        </div>
                        <div class="card-r-r">
                            <div class="text">
                                {{ $t('home.lock') }}:<span>{{Number(item.daybfb)/10}}%/30{{ $t('home.sky') }}</span>
                            </div>
                            <div class="btn" @click="buyNode(i)">{{ $t('node.subscription') }}</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div v-else-if="tabActive === 2">
            <div class="empty" v-if="empty">
                <img src="../../assets/img/node/empty.png" alt="">
                <div @click="dobuyNode()">
                    {{ $t('node.noNode') }}
                </div>
            </div>

            <template v-else>
                <div>
                    <div class="card1" v-for="(item,i) in mynode" :key="i">
                        <div>
                            <div class="card1-title">
                                {{getNodeName(item.nodeid)}}
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{item.wdReward}} YUX</div>
                                        <div class="value"> {{ $t('node.totalCollection') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{Number(item.yi-item.wdReward).toFixed(2)}} YUX</div>
                                        <div class="value"> {{ $t('node.toBeClaimed') }}</div>
                                    </div>

                                    <div>
                                        <div class="btn" @click="getWDReward(i)">{{ $t('node.claimed') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                            <div class="card1-content">
                                <div>
                                    <div>
                                        <div class="label">{{item.total}} YUX</div>
                                        <div class="value">{{ $t('node.totalRelease') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{Number(item.yi).toFixed(2)}} YUX</div>
                                        <div class="value">{{ $t('node.released') }}</div>
                                    </div>

                                    <div>
                                        <div class="label">{{Number(item.total - item.yi).toFixed(2)}} YUX</div>
                                        <div class="value">{{ $t('node.toBeReleased') }}</div>
                                    </div>
                                </div>
                                <div>

                                </div>
                            </div>
                        </div>
                    </div>

          
                </div>


                <div class="tags">
                    <!-- <div :class="{ active: release == 1 }" @click="release = 1">{{ $t('node.releaseRecord') }}</div> -->
                    <div :class="{ active: release == 2 }" @click="release = 2">{{ $t('node.claimRecord') }}</div>
                </div>
                <div v-if="release === 1">
                    <div class="release">
                        <div>
                            <div class="release-item">
                                <div>
                                    <div class="title">{{ $t('node.claimRecord') }}</div>
                                    <div class="num">+ 200 YUX</div>
                                </div>
                                <div>
                                    <div class="time">2025-10-29 13:23</div>
                                </div>
                            </div>

                            <div class="release-item">
                                <div>
                                    <div class="title">{{ $t('node.genesisReleased') }}</div>
                                    <div class="num">+ 200 YUX</div>
                                </div>
                                <div>
                                    <div class="time">2025-10-29 13:23</div>
                                </div>
                            </div>

                            <div class="release-item">
                                <div>
                                    <div class="title">{{ $t('node.genesisReleased') }}</div>
                                    <div class="num">+ 200 YUX</div>
                                </div>
                                <div>
                                    <div class="time">2025-10-29 13:23</div>
                                </div>
                            </div>
                            <!-- <div class="more">
                                {{ $t('node.more') }}
                            </div> -->
                        </div>
                    </div>
                </div>

                <div v-else-if="release === 2">
                    <div class="release release1">
                        <div>
                            <div class="release-item" v-for="(item,i) in getwdlist " :key="i">
                                <div>
                                    <div class="title">{{ getNodeName(item[1]) }}</div>
                                   <div class="num">+ {{item[2]}} YUX  <!--<img src="../../assets/img/node/icon6.png" alt=""> --> </div>
                                    
                                </div>
                                <div>
                                    <div class="time">{{item[0].slice(0,16) }}</div>
                                </div>
                            </div>

                            <!-- <div class="release-item">
                                <div>
                                    <div class="title">{{ $t('node.genesisReleased') }}</div>
                                    <div class="num">+ 200 YUX

                                        <img src="../../assets/img/node/icon6.png" alt="">
                                    </div>
                                </div>
                                <div>
                                    <div class="time">2025-10-29 13:23</div>
                                </div>
                            </div>

                            <div class="release-item">
                                <div>
                                    <div class="title">{{ $t('node.genesisReleased') }}</div>
                                    <div class="num">+ 200 YUX <img src="../../assets/img/node/icon6.png" alt=""></div>
                                </div>
                                <div>
                                    <div class="time">2025-10-29 13:23</div>
                                </div>
                            </div> -->
                          
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <!-- 节点认购 -->
           <Popup v-model="subscriptionShow" position="bottom" round get-container="#app">
           
            <div class="subscription-claim" >
                <div class="title">
                    {{ $t('node.executionSuccessful') }}
                    <img src="../../assets/img/node/icon7.png" @click="subscriptionShow = false" alt="">
                </div>
                <div class="claim-ok">
                    <img src="../../assets/img/node/claim.png" alt="">
                    <div class="title">
                        {{ $t('node.executionSuccessful') }}
                    </div>
                </div>

            </div>
        </Popup>
        <!-- 领取收益 -->
        <!-- <Popup v-model="show" position="bottom" round get-container="#app" @closed="onClose">
            <div v-if="!loading && !claimOk" class="revenue-popup">
                <div class="title">
                    {{ $t('node.claimIncome') }}
                    <img src="../../assets/img/node/icon7.png" @click="show = false" alt="">
                </div>
                <div class="label">
                    {{ $t('node.quantityClaimed') }}
                </div>
                <div class="ipt">
                    <Field v-model="value" placeholder="">
                        <template #extra>
                            <span class="aux">YUX</span>
                        </template>
                    </Field>
                </div>
                <div class="text">
                    {{ $t('node.pickup') }} 100 YUX
                    <span>{{ $t('node.all') }}</span>
                </div>
                <div class="desc">
                    <div>
                        <div>
                            <div class="label">{{ $t('node.receivedTo') }}</div>
                            <div class="value">0x2415a...c6aaec61bf4d</div>
                        </div>

                        <div>
                            <div class="label">{{ $t('node.networkFee') }}</div>
                            <div class="value">0.00032 BNB</div>
                        </div>

                        <div>
                            <div class="label">{{ $t('node.nonce') }}</div>
                            <div class="value">7</div>
                        </div>
                    </div>
                </div>
                <div class="btn" @click="handleClaim">
                    {{ $t('node.confirmToReceive') }}
                </div>
            </div>
            <div class="revenue-loading" v-if="loading">
                <div class="title">
                    {{ $t('node.progress') }}
                    <img src="../../assets/img/node/icon7.png" @click="show = false" alt="">
                </div>
                <div class="loading">
                    <div class="loader-inner ball-spin-fade-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <div class="desc">{{ $t('node.progress') }}</div>
            </div>
            <div class="revenue-claim" v-if="claimOk && !loading">
                <div class="title">
                    {{ $t('node.executionSuccessful') }}
                    <img src="../../assets/img/node/icon7.png" @click="show = false" alt="">
                </div>
                <div class="claim-ok">
                    <img src="../../assets/img/node/claim.png" alt="">
                    <div class="title">
                        {{ $t('node.executionSuccessful') }}
                    </div>
                    <div class="desc">
                        <span>{{ $t('node.at') }}Nexus Chain {{ $t('node.view') }}:0xe7d92</span>
                    </div>
                </div>

            </div>
        </Popup> -->
    </div>
</template>

<script>
import {
    Field,
    Swipe,
    SwipeItem,
    Circle,
    Tab,
    Tabs,
    Popup,
    Progress,
    Button,
} from "vant";
import { copyToClipboard } from "@/utils";
import NumberScroll from "@/components/NumberScroll.vue";
import SplitText from "@/components/SplitText/SplitText.vue";
import ShinyText from "@/components/ShinyText/ShinyText.vue";
import AnimatedContent from "@/components/AnimatedContent/AnimatedContent.vue";
import FadeContent from "@/components/FadeContent/FadeContent.vue";

import axios from 'axios'
import Web3 from 'web3'
import contractaa from '../contract/index.js'
let web3
web3 = new Web3(window.ethereum)

export default {
    name: "node",
    components: {
        SplitText,
        ShinyText,
        AnimatedContent,
        FadeContent,
        Field,
        Swipe,
        SwipeItem,
        Tab,
        VanCircle: Circle,
        Tabs,
        Popup,
        Progress,
        Button,
        NumberScroll,
    },
    data() {
        return {
            value: "100",
            tabActive: 1,
            release: 2,
            empty: false,
            show: false,
            claimOk: false,
            loading: false,


            subscriptionLoading: false,
            subscriptionShow: false,
            subscriptionOk: false,

            listnode:[],
            mynode:[],
            getwdlist:[],
        };
    },
    computed: {
         getNodeName(){
            return(v)=>{
                if(v==0){
                    return this.$t('node.node0')
                }else if(v==1){
                    return this.$t('node.node1')
                }else if(v==2){
                    return this.$t('node.node2')
                }else if(v==3){
                    return this.$t('node.node3')
                }else if(v==4){
                    return this.$t('node.node4')
                }else if(v==5){
                    return this.$t('node.node5')
                }
                
            }
        }
    },
    methods: {
        handleClaim() {
            this.loading = true;
            setTimeout(() => {
                this.claimOk = true;
                this.loading = false;

            }, 2000)
        },
        onClose() {
            this.loading = false;
            this.claimOk = false;
            this.show = false;

        },
        // handleSubscription() {
        //     this.subscriptionLoading = true;
        //     setTimeout(() => {
        //         this.subscriptionOk = true;
        //         this.subscriptionLoading = false;

        //     }, 2000)
        // },
        // onSubscriptionClose() {
        //     this.subscriptionLoading = false;
        //     this.subscriptionShow = false;
        //     this.subscriptionOk = false;

        // },
        dobuyNode(){
            this.tabActive=1
        },
        getImg(v){
            if(v==0){
               return require('../../assets/img/node/node1.png')
            }else if(v==1){
                return require('../../assets/img/node/node2.png')
            }else if(v==2){
                return require('../../assets/img/node/node3.png')
            }else if(v==3){
                return require('../../assets/img/node/node4.png')
            }else if(v==4){
                return require('../../assets/img/node/node5.png')
            }else if(v==5){
                return require('../../assets/img/node/node6.png')
            }
        },
        async getWDReward(v){
           
            let that = this;
            let address = this.$store.state.globalAddress;
            var NodeContract = new web3.eth.Contract(contractaa.abiNode,contractaa.nodeToken);

            await NodeContract.methods.getReward(address,v).call({from:address}).then(function(result){
                let rewardbalance = web3.utils.fromWei(result,'ether');
                if(rewardbalance <= 0){
                    that.$toast.fail(that.$t('node.error'));
                    return;
                }
            })
            this.$store.commit('handleShow', true)
            await NodeContract.methods.wdReward(v).send({from:address}).then(receipt => {
                //监听后续的交易情况
                if (receipt.status == "1") {
                    axios.get(contractaa.APIURL+'?cmd=addreward&re=0&tx='+receipt.transactionHash).then(function (response) {
                    if (response.status === 200) {
                            console.log("axios:"+response.data.Message)
                        }
                    })
                    that.$store.commit('handleLoading', false)
                    that.getInfo();
                    //that.subscriptionShow = true;
                } else {
                    that.$toast.fail(that.$t('node.error'));
                }          
            });
            //that.$toast.fail(v);
        },
        async buyNode(v){
            //console.log(v);
            //this.$toast.success('提示文案');

           
            // this.$store.commit('handleLoading', false)
            let that = this;
            let address = this.$store.state.globalAddress;
            var UsdtContract = new web3.eth.Contract(contractaa.abiUsdt,contractaa.usdtToken);
            var NodeContract = new web3.eth.Contract(contractaa.abiNode,contractaa.nodeToken);
            let _amount;
            let _yCount;
            await NodeContract.methods.nodeList(v).call({from:address}).then(function(result){
                _amount = web3.utils.fromWei(result[0],'ether');
               _yCount = Number(result[4]) - Number(result[5])
            }) 
            if(_yCount <= 0){
                that.$toast.fail(that.$t('node.nocount'));
                return;
            }
            that.$store.commit('handleShow', true)
            let maxmunber = '115792089237316195423570985008687907853269984665640564039457584007913129639935';

            UsdtContract.methods.allowance(address,contractaa.nodeToken).call({from:address}).then(function(result){
                //获取 result 授权数量
                let dd = web3.utils.fromWei(result,'ether')
                //console.log('授权数量'+dd);
                if(dd >= _amount){
                    NodeContract.methods.buyNode(v).send({from:address}).then(receipt => {
                        //监听后续的交易情况
                        if (receipt.status == "1") {
                            //that.$message.success("操作成功");
                            axios.get(contractaa.APIURL+'?cmd=buynode&re=0&tx='+receipt.transactionHash).then(function (response) {
                            if (response.status === 200) {
                                    console.log("axios:"+response.data.Message)
                                }
                            })
                            that.$store.commit('handleLoading', false)
                            that.getInfo();
                            //that.subscriptionShow = true;
                        } else {
                            that.$toast.fail(that.$t('node.error'));
                        }          
                    });
                }else{
                    UsdtContract.methods.approve(contractaa.nodeToken,maxmunber).send({from:address}).then(receipt => {
                        //监听后续的交易情况
                        if (receipt.status == "1") {
                            NodeContract.methods.buyNode(v).send({from:address}).then(receipt => {
                                    //监听后续的交易情况
                                    if (receipt.status == "1") {
                                        //that.$message.success("操作成功");
                                        axios.get(contractaa.APIURL+'?cmd=buynode&re=0&tx='+receipt.transactionHash).then(function (response) {
                                        if (response.status === 200) {
                                                console.log("axios:"+response.data.Message)
                                            }
                                        })
                                        that.$store.commit('handleLoading', false)
                                        that.getInfo();
                                        //that.subscriptionShow = true;
                                    } else {
                                        that.$toast.fail(that.$t('node.error'));
                                    }          
                                });

                        } else {
                           that.$toast.fail(that.$t('node.error'));
                        }          
                    });
                }
            })  
        },
        async getInfo(){
            //this.listnode = [{price:3,count:0,usecount:0},{price:4,count:10,usecount:1}]
            let that = this;
            let address = this.$store.state.globalAddress;
            let NodeContract = new web3.eth.Contract(contractaa.abiNode,contractaa.nodeToken);
            await NodeContract.methods.getNodeList().call({from:address}).then(function(result){
                var _result = result;
                that.listnode = _result;
                for(var i=0;i<_result.length;i++){
                    that.listnode[i].price = web3.utils.fromWei(_result[i].price,'ether')
                }
            })

            let _startTp;
            await await NodeContract.methods.startSP().call({from:address}).then(function(result){
                _startTp = result;
            })
            let _rewardsecond;
            await await NodeContract.methods.rewardsencond().call({from:address}).then(function(result){
                _rewardsecond = result;
            })

            let _nottp;
            await await NodeContract.methods.gettimestamp().call({from:address}).then(function(result){
                _nottp = result;
            })
            let _count = 0;
            if(_startTp > 0 &&  _nottp > _startTp){
                _count = (_nottp-_startTp)/_rewardsecond
            }
            // console.log("_nottp:"+_nottp);
            // console.log("_startTp:"+_startTp);
            // console.log("_rewardsecond:"+_rewardsecond);
            // console.log("count:"+_count);

            await NodeContract.methods.getUserNodeList(address).call({from:address}).then(function(result){
                var _result = result;
                that.mynode = _result;
                if(_result.length==0){
                    that.empty = true;
                    return;
                }
                for(var i=0;i<_result.length;i++){
                    that.mynode[i].dayamount = Number(web3.utils.fromWei(_result[i].dayamount,'ether'))
                    let _dayamount = that.mynode[i].dayamount
                    that.mynode[i].yi = Number(_count) * Number(_dayamount)
                   
                    that.mynode[i].wdReward = Number(web3.utils.fromWei(_result[i].wdReward,'ether'))
                    that.mynode[i].total = Number(web3.utils.fromWei(_result[i].total,'ether'))
                    if(that.mynode[i].yi > that.mynode[i].total){
                        that.mynode[i].yi = that.mynode[i].total
                    }
                }
                console.log(that.mynode)
            })

            axios.get(contractaa.APIURL+'?cmd=getwdlist&addr='+address).then(function (response) {
            if (response.status === 200) {
                    //console.log("axios:"+response.data.Data)
                    that.getwdlist = response.data.Data
                }
            })

        },
    },
    mounted() {
        let timer = setInterval(async () => {
            if (true) {
                this.getInfo()
                clearInterval(timer)
            }
        }, 500);
    },
};
</script>

<style lang="less" scoped>
.node {
    width: 375px;
    // overflow-x: hidden;
    // height: 100%;
    position: relative;
    //overflow-y: auto;
    
    //min-height: 100%;
    background-size: 100% 800px;
    padding: 0 16px 42px;
    background: url("../../assets/img/home/header-bg.png") no-repeat;
    background-size: 471.9px 240.62px;
    background-position: -60px -97px;
    flex: 1;

    &-bg {
        width: 637.18px;
        position: absolute;
        height: 294px;
        top: -92px;
        left: 50%;
        transform: translateX(-50%);
        background: url('../../assets/img/node/bg.png') no-repeat center;
        background-size: 100% 100%;
    }

    .placeholder {
        height: 34px;
    }

    .px15 {
        padding: 0 15px;
    }

    .node-swipe {
        margin-top: 24px;

        .swipe {
            border-radius: 16px;

            .swipe-item {
                background: url('../../assets/img/node/swipe-bg.png') no-repeat;
                background-size: 100% 100%;
                padding: 1px;
            }
        }
    }

    .tags {
        margin-top: 32px;
        display: flex;
        font-size: 16px;
        line-height: 16px;

        >div {
            opacity: 0.5;
            margin-right: 24px;

            &.active {
                font-weight: bold;
                opacity: 1;
            }
        }
    }


    .card {
        margin-top: 16px;
        box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);
        background: conic-gradient(from 103deg at 52% 41%, rgba(249, 249, 249, 0.25) -33deg, rgba(64, 64, 64, 0.25) 11deg, rgba(64, 64, 64, 0.175) 32deg, rgba(255, 255, 255, 0.25) 60deg, rgba(255, 255, 255, 0.25) 108deg, rgba(64, 64, 64, 0.175) 188deg, rgba(249, 249, 249, 0.5) 208deg, rgba(255, 255, 255, 0.25) 287deg, rgba(249, 249, 249, 0.25) 327deg, rgba(64, 64, 64, 0.25) 371deg);
        border-radius: 16px;
        padding: 1px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        >div {
            background: linear-gradient(241deg, #1E1D24 9%, #13121B 78%);
            backdrop-filter: blur(30px);
            border-radius: 16px;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            display: flex;
            justify-content: space-between;
            padding: 14px 12px;
        }


        &-l {
            height: 88px;
            width: 88px;
            border-radius: 8px;
            background: url('../../assets/img/home/icon-bg.png')no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            justify-content: center;

        }

        &-r {
            margin-left: 12px;
            flex: 1;
            padding-top: 8px;
            padding-bottom: 2px;
            display: flex;
            color: #FFFFFF;

            &-l {
                flex: 1;
                font-size: 16px;
                line-height: 16px;

                >div {
                    margin-bottom: 15px;
                }

                &-b {
                    margin-top: 19px;
                    line-height: 12px;
                    font-weight: 500;
                    font-size: 12px;
                    opacity: 0.6;
                    margin-bottom: 0 !important;
                }
            }

            &-r {
                padding: 2px 0;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-end;

                .text {
                    font-size: 12px;
                    line-height: 12px;
                    font-weight: 500;
                       max-width: 120px;
                    text-align: right;
                    span {
                        background-image: -webkit-linear-gradient(134deg, #0DF1D5 2%, #0190D1 98%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }
                }

                .btn {
                    width: 76px;
                    height: 32px;
                    cursor: pointer;
                    border-radius: 8px;
                    font-size: 14px;
                    display: flex;
                    color: #000000;
                    align-items: center;
                    justify-content: center;
                    background: linear-gradient(112deg, #0DF1D5 0%, #0190D1 97%);
                }
            }
        }
    }

    .empty {
        padding-top: 64px;
        display: flex;
        flex-direction: column;
        align-items: center;

        >img {
            width: 160px;
            height: 160px;
        }

        >div {
            margin-top: 27px;
            line-height: 14px;
            font-size: 14px;
            height: 32px;
            font-weight: 500;
            border-radius: 8px;
            padding: 0 12px;
            display: flex;
            align-items: center;
            color: #000000;
            background: linear-gradient(101deg, #0DF1D5 0%, #0190D1 97%);
        }
    }

    .card1 {
        height: 156px;
        border-radius: 16px;
        background: #FFFCF5;
        margin-top: 16px;
        box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);
        background: conic-gradient(from 103deg at 52% 41%, rgba(249, 249, 249, 0.25) -33deg, rgba(64, 64, 64, 0.25) 11deg, rgba(64, 64, 64, 0.175) 32deg, rgba(255, 255, 255, 0.25) 60deg, rgba(255, 255, 255, 0.25) 108deg, rgba(64, 64, 64, 0.175) 188deg, rgba(249, 249, 249, 0.5) 208deg, rgba(255, 255, 255, 0.25) 287deg, rgba(249, 249, 249, 0.25) 327deg, rgba(64, 64, 64, 0.25) 371deg);
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        >div {
            background: linear-gradient(241deg, #1E1D24 9%, #13121B 78%);
            backdrop-filter: blur(30px);
            border-radius: 16px;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            padding: 16px;
        }

        &-title {
            font-size: 16px;
            line-height: 16px;
            margin-bottom: 16px;
        }

        &-content {
            >div {
                display: flex;

                >div {
                    flex: 1;

                    .label {
                        font-size: 14px;
                        font-weight: 500;
                        line-height: 16px;
                        margin-bottom: 6px;
                    }

                    .value {
                        line-height: 12px;
                        font-size: 12px;
                        opacity: 0.6;
                    }

                    .btn {
                        color: #000000;
                        height: 32px;
                        border-radius: 8px;
                        cursor: pointer;
                        font-weight: 500;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 14px;
                        width: 76px;
                        background: linear-gradient(112deg, #0DF1D5 0%, #0190D1 97%);
                    }
                }

            }

            >div+div {
                margin-top: 20px;
            }
        }
    }

    .release {
        border-radius: 16px;
        background: #FFFCF5;
        margin-top: 16px;
        box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);
        background: conic-gradient(from 103deg at 52% 41%, rgba(249, 249, 249, 0.25) -33deg, rgba(64, 64, 64, 0.25) 11deg, rgba(64, 64, 64, 0.175) 32deg, rgba(255, 255, 255, 0.25) 60deg, rgba(255, 255, 255, 0.25) 108deg, rgba(64, 64, 64, 0.175) 188deg, rgba(249, 249, 249, 0.5) 208deg, rgba(255, 255, 255, 0.25) 287deg, rgba(249, 249, 249, 0.25) 327deg, rgba(64, 64, 64, 0.25) 371deg);
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        >div {
            background: linear-gradient(241deg, #1E1D24 9%, #13121B 78%);
            backdrop-filter: blur(30px);
            border-radius: 16px;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            padding: 0 16px;

            >div+div {
                border-top: 1px solid #2A2A2A;
            }

            .release-item {
                padding: 16px 0;

                >div {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .title {
                        font-size: 14px;
                        line-height: 14px;
                    }

                    .num {
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        font-weight: bold;
                        color: #05B9D0;

                        >img {
                            width: 16px;
                            height: 16px;
                            margin-left: 8px;
                        }
                    }

                    .time {
                        margin-top: 8px;
                        font-size: 12px;
                        line-height: 14px;
                        opacity: 0.6;
                    }
                }
            }

            .more {
                text-align: center;
                padding: 16px 0;
                opacity: 0.6;
                line-height: 14px;
                font-size: 12px;

            }
        }
    }

    .release1 {
        .num {
            font-weight: 500 !important;

        }
    }
}
</style>
<style lang="less">
.node {
    .node-swipe {
        .swipe .van-swipe-item {
            color: #fff;
            font-size: 20px;
            height: 160px;
            text-align: center;
        }
    }
    .van-swipe__indicators {
        right: 12px;
        bottom: 12px;
        left: auto;
    }
}

.revenue-popup {
    padding: 32px 20px 40px;
    border: 1px solid rgba(255, 255, 255, 0.5);

    >.title {
        display: flex;
        justify-content: space-between;
        line-height: 16px;
        font-size: 16px;

        >img {
            width: 20px;
            height: 20px;
        }
    }

    >.label {
        margin-top: 20px;
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 16px;
    }

    >.ipt {
        height: 48px;
        background: #16151D;
        border-radius: 16px;
        display: flex;
        align-items: center;

        .van-cell {
            background: transparent;

            .van-field__control {
                font-weight: 500;
                font-size: 14px;
                color: #FFFFFF;
            }
        }

        .aux {
            color: #FFFFFF;
            font-size: 14px;
        }
    }

    >.text {
        margin-top: 12px;
        text-align: right;
        font-size: 14px;

        span {
            color: #05B9D0;
            margin-left: 16px;
        }
    }

    >.desc {
        margin-top: 20px;
        box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);
        background: conic-gradient(from 103deg at 52% 41%, rgba(249, 249, 249, 0.25) -33deg, rgba(64, 64, 64, 0.25) 11deg, rgba(64, 64, 64, 0.175) 32deg, rgba(255, 255, 255, 0.25) 60deg, rgba(255, 255, 255, 0.25) 108deg, rgba(64, 64, 64, 0.175) 188deg, rgba(249, 249, 249, 0.5) 208deg, rgba(255, 255, 255, 0.25) 287deg, rgba(249, 249, 249, 0.25) 327deg, rgba(64, 64, 64, 0.25) 371deg);
        border-radius: 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        >div {
            background: linear-gradient(241deg, #1E1D24 9%, #13121B 78%);
            backdrop-filter: blur(30px);
            border-radius: 16px;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            border-radius: 16px;
            padding: 16px;

            >div+div {
                margin-top: 16px;
            }

            >div {
                display: flex;
                justify-content: space-between;

                .label {
                    opacity: 0.6;
                    font-size: 14px;
                    letter-spacing: -0.25px;
                }

                .value {
                    letter-spacing: -0.25px;
                    font-size: 14px;
                }
            }
        }
    }

    >.btn {
        background: url('../../assets/img/node/btn.png') no-repeat;
        background-size: 100% 100%;
        border-radius: 16px;
        display: flex;
        cursor: pointer;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        height: 48px;
        color: #000000;
        margin-top: 36px;
    }
}

.revenue-loading,
.subscription-loading {
    padding: 32px 20px 80px;

    >.title {
        display: flex;
        justify-content: space-between;
        line-height: 16px;
        font-size: 16px;

        >img {
            width: 20px;
            height: 20px;
        }
    }

    >.loading {
        padding-top: 64px;
        display: flex;
        height: 100px;
        justify-content: center;

        @keyframes ball-spin-fade-loader {
            50% {
                opacity: 0.3;
                -webkit-transform: scale(0.4);
                transform: scale(0.4);
            }

            100% {
                opacity: 1;
                -webkit-transform: scale(1);
                transform: scale(1);
            }
        }

        .ball-spin-fade-loader {
            position: relative;
            margin-left: -15px;
        }

        .ball-spin-fade-loader>div:nth-child(1) {
            top: 25px;
            left: 0;
            -webkit-animation: ball-spin-fade-loader 1s 0s infinite linear;
            animation: ball-spin-fade-loader 1s 0s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(2) {
            top: 17.04545px;
            left: 17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.12s infinite linear;
            animation: ball-spin-fade-loader 1s 0.12s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(3) {
            top: 0;
            left: 25px;
            -webkit-animation: ball-spin-fade-loader 1s 0.24s infinite linear;
            animation: ball-spin-fade-loader 1s 0.24s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(4) {
            top: -17.04545px;
            left: 17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.36s infinite linear;
            animation: ball-spin-fade-loader 1s 0.36s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(5) {
            top: -25px;
            left: 0;
            -webkit-animation: ball-spin-fade-loader 1s 0.48s infinite linear;
            animation: ball-spin-fade-loader 1s 0.48s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(6) {
            top: -17.04545px;
            left: -17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.6s infinite linear;
            animation: ball-spin-fade-loader 1s 0.6s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(7) {
            top: 0;
            left: -25px;
            -webkit-animation: ball-spin-fade-loader 1s 0.72s infinite linear;
            animation: ball-spin-fade-loader 1s 0.72s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(8) {
            top: 17.04545px;
            left: -17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.84s infinite linear;
            animation: ball-spin-fade-loader 1s 0.84s infinite linear;
        }

        .ball-spin-fade-loader>div {
            background: linear-gradient(133deg, #0DF1D5 2%, #0190D1 98%);
            width: 15px;
            height: 15px;
            border-radius: 100%;
            margin: 2px;
            -webkit-animation-fill-mode: both;
            animation-fill-mode: both;
            position: absolute;
        }
    }

    >.desc {
        margin-top: 16px;
        text-align: center;
        letter-spacing: -0.25px;
        font-size: 14px;
        opacity: 0.6;
    }
}

.revenue-claim,
.subscription-claim {
    padding: 32px 20px 80px;
    backdrop-filter: blur(46px);
    border-top: 1px solid rgba(255, 255, 255, 0.5);

    >.title {
        display: flex;
        justify-content: space-between;
        line-height: 16px;
        font-size: 16px;

        >img {
            width: 20px;
            height: 20px;
        }
    }

    .claim-ok {
        padding-top: 48px;

        >img {
            width: 120px;
            height: 120px;
            margin: 0 auto;
        }

        >.title {
            font-size: 18px;
            margin-top: 16px;
            text-align: center;
            letter-spacing: -0.25px;
        }

        >.desc {
            font-size: 14px;
            margin-top: 8px;
            letter-spacing: -0.25px;
            display: flex;
            align-items: center;
            justify-content: center;

            span {
                opacity: 0.6;

            }

            img {
                width: 16px;
                height: 16px;
                margin-left: 7px;
            }
        }
    }

}
</style>